/**
 * @fileoverview gRPC-Web generated client stub for user.company
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


import * as grpcWeb from 'grpc-web';

import {
  AcceptUserTermsConditionsRequest,
  AcceptUserTermsConditionsResponse,
  AddUsersToPointRequest,
  AddUsersToPointResponse,
  CountUsersByFiltersRequest,
  CountUsersByFiltersResponse,
  GetBalanceRequest,
  GetBalanceResponse,
  GetBillingDataRequest,
  GetBillingDataResponse,
  GetCitiesRequest,
  GetCitiesResponse,
  GetIdentificationTypeRequest,
  GetIdentificationTypeResponse,
  GetProfileDataRequest,
  GetProfileDataResponse,
  GetRolesRequest,
  GetRolesResponse,
  GetUserByPointRequest,
  GetUserByPointResponse,
  GetUserListByCompanyIdRequest,
  GetUserListByCompanyIdResponse,
  GetUserTermsConditionsCheckRequest,
  GetUserTermsConditionsCheckResponse,
  GetUserTermsConditionsRequest,
  GetUserTermsConditionsResponse,
  GetUsersSegmentRequest,
  GetUsersSegmentResponse,
  MassivePointAssignRequest,
  MassivePointAssignResponse,
  MassiveUserToPointAssignRequest,
  MassiveUserToPointAssignResponse,
  RegisterUserCompanyRequest,
  RegisterUserCompanyResponse,
  RegisterUserRequest,
  RegisterUserResponse,
  SendVerificationCodeRequest,
  SendVerificationCodeResponse,
  UpdateBillingDataRequest,
  UpdateBillingDataResponse,
  UpdateCompanyProfileDataRequest,
  UpdateProfileDataResponse,
  UpdateUserPointsRequest,
  UpdateUserPointsResponse,
  UpdateUserProfileDataRequest,
  UpdateUserRoleRequest,
  UpdateUserRoleResponse,
  ValidateEmailUserRequest,
  ValidateEmailUserResponse,
  ValidateIdentificationUserRequest,
  ValidateIdentificationUserResponse,
  ValidatePhoneRequest,
  ValidatePhoneResponse,
  ValidateVerificationCodeRequest,
  ValidateVerificationCodeResponse} from './user.api_pb';

export class UserCompanyControllerClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials: null | { [index: string]: string; },
               options: null | { [index: string]: string; }) {
    if (!options) options = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoGetUserListByCompanyId = new grpcWeb.AbstractClientBase.MethodInfo(
    GetUserListByCompanyIdResponse,
    (request: GetUserListByCompanyIdRequest) => {
      return request.serializeBinary();
    },
    GetUserListByCompanyIdResponse.deserializeBinary
  );

  getUserListByCompanyId(
    request: GetUserListByCompanyIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetUserListByCompanyIdResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/GetUserListByCompanyId',
      request,
      metadata || {},
      this.methodInfoGetUserListByCompanyId,
      callback);
  }

  methodInfoRegisterUser = new grpcWeb.AbstractClientBase.MethodInfo(
    RegisterUserResponse,
    (request: RegisterUserRequest) => {
      return request.serializeBinary();
    },
    RegisterUserResponse.deserializeBinary
  );

  registerUser(
    request: RegisterUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: RegisterUserResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/RegisterUser',
      request,
      metadata || {},
      this.methodInfoRegisterUser,
      callback);
  }

  methodInfoRegisterUserCompany = new grpcWeb.AbstractClientBase.MethodInfo(
    RegisterUserCompanyResponse,
    (request: RegisterUserCompanyRequest) => {
      return request.serializeBinary();
    },
    RegisterUserCompanyResponse.deserializeBinary
  );

  registerUserCompany(
    request: RegisterUserCompanyRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: RegisterUserCompanyResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/RegisterUserCompany',
      request,
      metadata || {},
      this.methodInfoRegisterUserCompany,
      callback);
  }

  methodInfoValidateEmailUser = new grpcWeb.AbstractClientBase.MethodInfo(
    ValidateEmailUserResponse,
    (request: ValidateEmailUserRequest) => {
      return request.serializeBinary();
    },
    ValidateEmailUserResponse.deserializeBinary
  );

  validateEmailUser(
    request: ValidateEmailUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: ValidateEmailUserResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/ValidateEmailUser',
      request,
      metadata || {},
      this.methodInfoValidateEmailUser,
      callback);
  }

  methodInfoUpdateUserPoints = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateUserPointsResponse,
    (request: UpdateUserPointsRequest) => {
      return request.serializeBinary();
    },
    UpdateUserPointsResponse.deserializeBinary
  );

  updateUserPoints(
    request: UpdateUserPointsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateUserPointsResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/UpdateUserPoints',
      request,
      metadata || {},
      this.methodInfoUpdateUserPoints,
      callback);
  }

  methodInfoUpdateUserRole = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateUserRoleResponse,
    (request: UpdateUserRoleRequest) => {
      return request.serializeBinary();
    },
    UpdateUserRoleResponse.deserializeBinary
  );

  updateUserRole(
    request: UpdateUserRoleRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateUserRoleResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/UpdateUserRole',
      request,
      metadata || {},
      this.methodInfoUpdateUserRole,
      callback);
  }

  methodInfoGetCities = new grpcWeb.AbstractClientBase.MethodInfo(
    GetCitiesResponse,
    (request: GetCitiesRequest) => {
      return request.serializeBinary();
    },
    GetCitiesResponse.deserializeBinary
  );

  getCities(
    request: GetCitiesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetCitiesResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/GetCities',
      request,
      metadata || {},
      this.methodInfoGetCities,
      callback);
  }

  methodInfoGetRoles = new grpcWeb.AbstractClientBase.MethodInfo(
    GetRolesResponse,
    (request: GetRolesRequest) => {
      return request.serializeBinary();
    },
    GetRolesResponse.deserializeBinary
  );

  getRoles(
    request: GetRolesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetRolesResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/GetRoles',
      request,
      metadata || {},
      this.methodInfoGetRoles,
      callback);
  }

  methodInfoAddUsersToPoint = new grpcWeb.AbstractClientBase.MethodInfo(
    AddUsersToPointResponse,
    (request: AddUsersToPointRequest) => {
      return request.serializeBinary();
    },
    AddUsersToPointResponse.deserializeBinary
  );

  addUsersToPoint(
    request: AddUsersToPointRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: AddUsersToPointResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/AddUsersToPoint',
      request,
      metadata || {},
      this.methodInfoAddUsersToPoint,
      callback);
  }

  methodInfoGetUserByPoint = new grpcWeb.AbstractClientBase.MethodInfo(
    GetUserByPointResponse,
    (request: GetUserByPointRequest) => {
      return request.serializeBinary();
    },
    GetUserByPointResponse.deserializeBinary
  );

  getUserByPoint(
    request: GetUserByPointRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetUserByPointResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/GetUserByPoint',
      request,
      metadata || {},
      this.methodInfoGetUserByPoint,
      callback);
  }

  methodInfoMassivePointAssign = new grpcWeb.AbstractClientBase.MethodInfo(
    MassivePointAssignResponse,
    (request: MassivePointAssignRequest) => {
      return request.serializeBinary();
    },
    MassivePointAssignResponse.deserializeBinary
  );

  massivePointAssign(
    request: MassivePointAssignRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: MassivePointAssignResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/MassivePointAssign',
      request,
      metadata || {},
      this.methodInfoMassivePointAssign,
      callback);
  }

  methodInfoMassiveUserToPointAssign = new grpcWeb.AbstractClientBase.MethodInfo(
    MassiveUserToPointAssignResponse,
    (request: MassiveUserToPointAssignRequest) => {
      return request.serializeBinary();
    },
    MassiveUserToPointAssignResponse.deserializeBinary
  );

  massiveUserToPointAssign(
    request: MassiveUserToPointAssignRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: MassiveUserToPointAssignResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/MassiveUserToPointAssign',
      request,
      metadata || {},
      this.methodInfoMassiveUserToPointAssign,
      callback);
  }

  methodInfoCountUsersByFilters = new grpcWeb.AbstractClientBase.MethodInfo(
    CountUsersByFiltersResponse,
    (request: CountUsersByFiltersRequest) => {
      return request.serializeBinary();
    },
    CountUsersByFiltersResponse.deserializeBinary
  );

  countUsersByFilters(
    request: CountUsersByFiltersRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: CountUsersByFiltersResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/CountUsersByFilters',
      request,
      metadata || {},
      this.methodInfoCountUsersByFilters,
      callback);
  }

  methodInfoSendVerificationCode = new grpcWeb.AbstractClientBase.MethodInfo(
    SendVerificationCodeResponse,
    (request: SendVerificationCodeRequest) => {
      return request.serializeBinary();
    },
    SendVerificationCodeResponse.deserializeBinary
  );

  sendVerificationCode(
    request: SendVerificationCodeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: SendVerificationCodeResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/SendVerificationCode',
      request,
      metadata || {},
      this.methodInfoSendVerificationCode,
      callback);
  }

  methodInfoValidateVerificationCode = new grpcWeb.AbstractClientBase.MethodInfo(
    ValidateVerificationCodeResponse,
    (request: ValidateVerificationCodeRequest) => {
      return request.serializeBinary();
    },
    ValidateVerificationCodeResponse.deserializeBinary
  );

  validateVerificationCode(
    request: ValidateVerificationCodeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: ValidateVerificationCodeResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/ValidateVerificationCode',
      request,
      metadata || {},
      this.methodInfoValidateVerificationCode,
      callback);
  }

  methodInfoValidatePhone = new grpcWeb.AbstractClientBase.MethodInfo(
    ValidatePhoneResponse,
    (request: ValidatePhoneRequest) => {
      return request.serializeBinary();
    },
    ValidatePhoneResponse.deserializeBinary
  );

  validatePhone(
    request: ValidatePhoneRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: ValidatePhoneResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/ValidatePhone',
      request,
      metadata || {},
      this.methodInfoValidatePhone,
      callback);
  }

  methodInfoGetIdentificationType = new grpcWeb.AbstractClientBase.MethodInfo(
    GetIdentificationTypeResponse,
    (request: GetIdentificationTypeRequest) => {
      return request.serializeBinary();
    },
    GetIdentificationTypeResponse.deserializeBinary
  );

  getIdentificationType(
    request: GetIdentificationTypeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetIdentificationTypeResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/GetIdentificationType',
      request,
      metadata || {},
      this.methodInfoGetIdentificationType,
      callback);
  }

  methodInfoGetBillingData = new grpcWeb.AbstractClientBase.MethodInfo(
    GetBillingDataResponse,
    (request: GetBillingDataRequest) => {
      return request.serializeBinary();
    },
    GetBillingDataResponse.deserializeBinary
  );

  getBillingData(
    request: GetBillingDataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetBillingDataResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/GetBillingData',
      request,
      metadata || {},
      this.methodInfoGetBillingData,
      callback);
  }

  methodInfoUpdateBillingData = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateBillingDataResponse,
    (request: UpdateBillingDataRequest) => {
      return request.serializeBinary();
    },
    UpdateBillingDataResponse.deserializeBinary
  );

  updateBillingData(
    request: UpdateBillingDataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateBillingDataResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/UpdateBillingData',
      request,
      metadata || {},
      this.methodInfoUpdateBillingData,
      callback);
  }

  methodInfoGetUsersSegment = new grpcWeb.AbstractClientBase.MethodInfo(
    GetUsersSegmentResponse,
    (request: GetUsersSegmentRequest) => {
      return request.serializeBinary();
    },
    GetUsersSegmentResponse.deserializeBinary
  );

  getUsersSegment(
    request: GetUsersSegmentRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetUsersSegmentResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/GetUsersSegment',
      request,
      metadata || {},
      this.methodInfoGetUsersSegment,
      callback);
  }

  methodInfoGetBalance = new grpcWeb.AbstractClientBase.MethodInfo(
    GetBalanceResponse,
    (request: GetBalanceRequest) => {
      return request.serializeBinary();
    },
    GetBalanceResponse.deserializeBinary
  );

  getBalance(
    request: GetBalanceRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetBalanceResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/GetBalance',
      request,
      metadata || {},
      this.methodInfoGetBalance,
      callback);
  }

  methodInfoGetUserTermsConditions = new grpcWeb.AbstractClientBase.MethodInfo(
    GetUserTermsConditionsResponse,
    (request: GetUserTermsConditionsRequest) => {
      return request.serializeBinary();
    },
    GetUserTermsConditionsResponse.deserializeBinary
  );

  getUserTermsConditions(
    request: GetUserTermsConditionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetUserTermsConditionsResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/GetUserTermsConditions',
      request,
      metadata || {},
      this.methodInfoGetUserTermsConditions,
      callback);
  }

  methodInfoGetUserTermsConditionsCheck = new grpcWeb.AbstractClientBase.MethodInfo(
    GetUserTermsConditionsCheckResponse,
    (request: GetUserTermsConditionsCheckRequest) => {
      return request.serializeBinary();
    },
    GetUserTermsConditionsCheckResponse.deserializeBinary
  );

  getUserTermsConditionsCheck(
    request: GetUserTermsConditionsCheckRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetUserTermsConditionsCheckResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/GetUserTermsConditionsCheck',
      request,
      metadata || {},
      this.methodInfoGetUserTermsConditionsCheck,
      callback);
  }

  methodInfoAcceptUserTermsConditions = new grpcWeb.AbstractClientBase.MethodInfo(
    AcceptUserTermsConditionsResponse,
    (request: AcceptUserTermsConditionsRequest) => {
      return request.serializeBinary();
    },
    AcceptUserTermsConditionsResponse.deserializeBinary
  );

  acceptUserTermsConditions(
    request: AcceptUserTermsConditionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: AcceptUserTermsConditionsResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/AcceptUserTermsConditions',
      request,
      metadata || {},
      this.methodInfoAcceptUserTermsConditions,
      callback);
  }

  methodInfoUpdateUserTermsConditions = new grpcWeb.AbstractClientBase.MethodInfo(
    AcceptUserTermsConditionsResponse,
    (request: AcceptUserTermsConditionsRequest) => {
      return request.serializeBinary();
    },
    AcceptUserTermsConditionsResponse.deserializeBinary
  );

  updateUserTermsConditions(
    request: AcceptUserTermsConditionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: AcceptUserTermsConditionsResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/UpdateUserTermsConditions',
      request,
      metadata || {},
      this.methodInfoUpdateUserTermsConditions,
      callback);
  }

  methodInfoValidateIdentificationUser = new grpcWeb.AbstractClientBase.MethodInfo(
    ValidateIdentificationUserResponse,
    (request: ValidateIdentificationUserRequest) => {
      return request.serializeBinary();
    },
    ValidateIdentificationUserResponse.deserializeBinary
  );

  validateIdentificationUser(
    request: ValidateIdentificationUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: ValidateIdentificationUserResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/ValidateIdentificationUser',
      request,
      metadata || {},
      this.methodInfoValidateIdentificationUser,
      callback);
  }

  methodInfoGetProfileData = new grpcWeb.AbstractClientBase.MethodInfo(
    GetProfileDataResponse,
    (request: GetProfileDataRequest) => {
      return request.serializeBinary();
    },
    GetProfileDataResponse.deserializeBinary
  );

  getProfileData(
    request: GetProfileDataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetProfileDataResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/GetProfileData',
      request,
      metadata || {},
      this.methodInfoGetProfileData,
      callback);
  }

  methodInfoUpdateUserProfileData = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateProfileDataResponse,
    (request: UpdateUserProfileDataRequest) => {
      return request.serializeBinary();
    },
    UpdateProfileDataResponse.deserializeBinary
  );

  updateUserProfileData(
    request: UpdateUserProfileDataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateProfileDataResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/UpdateUserProfileData',
      request,
      metadata || {},
      this.methodInfoUpdateUserProfileData,
      callback);
  }

  methodInfoUpdateCompanyProfileData = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateProfileDataResponse,
    (request: UpdateCompanyProfileDataRequest) => {
      return request.serializeBinary();
    },
    UpdateProfileDataResponse.deserializeBinary
  );

  updateCompanyProfileData(
    request: UpdateCompanyProfileDataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateProfileDataResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/user.company.UserCompanyController/UpdateCompanyProfileData',
      request,
      metadata || {},
      this.methodInfoUpdateCompanyProfileData,
      callback);
  }

}

